import { Controller } from '@hotwired/stimulus'
import FlashController from './flash_controller'

export default class ReplacementController extends Controller {
  static targets = ['form', 'content', 'overlay', 'guide']

  showLoader () {
    if (this.formTarget.checkValidity()) {
      FlashController.prototype.renderFlash('Syncing Data, it may take some time.', 'success')
      this.overlayTarget.classList.remove('hidden')
      this.contentTarget.classList.add('hidden')
    }
  }

  // Shows the kit replacement instructions for the clicked shelter type; clicking it again hides them.
  showGuide (event) {
    const { slug } = event.params

    this.guideTargets.forEach(guide => {
      const isSelected = guide.dataset.slug === slug
      guide.classList.toggle('hidden', !isSelected || !guide.classList.contains('hidden'))
    })
  }
}
